import { createStitches } from '@stitches/react'
import type * as Stitches from '@stitches/react'
import { ReservoirKitTheme } from './src/themes/ReservoirKitTheme'

export type CSS = Stitches.CSS<typeof config>
export type CSSProps = { css?: CSS }

export const {
  createTheme,
  keyframes,
  styled,
  globalCss,
  getCssText,
  theme,
  config,
} = createStitches({
  theme: {
    space: {
      1: '4px',
      2: '8px',
      3: '12px',
      4: '16px',
      5: '32px',
      6: '64px',
    },
    fontSizes: {},
    fontWeights: {},
    fonts: {
      body: 'sans-serif',
      button: '$body',
    },
    lineHeights: {},
    letterSpacings: {},
    sizes: {},
    radii: {
      borderRadius: 0,
    },
    shadows: {},
    transitions: {},
  },
  utils: {
    // MARGIN
    m: (value: Stitches.PropertyValue<'margin'>) => ({
      margin: value,
    }),
    mx: (value: Stitches.PropertyValue<'margin'>) => ({
      marginLeft: value,
      marginRight: value,
    }),
    my: (value: Stitches.PropertyValue<'margin'>) => ({
      marginTop: value,
      marginBottom: value,
    }),
    mt: (value: Stitches.PropertyValue<'margin'>) => ({
      marginTop: value,
    }),
    mb: (value: Stitches.PropertyValue<'margin'>) => ({
      marginBottom: value,
    }),
    ml: (value: Stitches.PropertyValue<'margin'>) => ({
      marginLeft: value,
    }),
    mr: (value: Stitches.PropertyValue<'margin'>) => ({
      marginRight: value,
    }),

    // PADDING
    p: (value: Stitches.PropertyValue<'padding'>) => ({
      padding: value,
    }),
    px: (value: Stitches.PropertyValue<'padding'>) => ({
      paddingLeft: value,
      paddingRight: value,
    }),
    py: (value: Stitches.PropertyValue<'padding'>) => ({
      paddingTop: value,
      paddingBottom: value,
    }),
    pt: (value: Stitches.PropertyValue<'padding'>) => ({
      paddingTop: value,
    }),
    pb: (value: Stitches.PropertyValue<'padding'>) => ({
      paddingBottom: value,
    }),
    pl: (value: Stitches.PropertyValue<'padding'>) => ({
      paddingLeft: value,
    }),
    pr: (value: Stitches.PropertyValue<'padding'>) => ({
      paddingRight: value,
    }),
    // DIMENSIONS
    w: (value: Stitches.PropertyValue<'width'>) => ({
      width: value,
    }),
    h: (value: Stitches.PropertyValue<'height'>) => ({
      height: value,
    }),
    size: (value: Stitches.PropertyValue<'width'>) => ({
      width: value,
      height: value,
    }),
  },
  media: {
    bp1: '(min-width: 600px)',
    bp2: '(min-width: 905px)',
    bp3: '(min-width: 1240px)',
    bp4: '(min-width: 1440px)',
    motion: '(prefers-reduced-motion)',
    hover: '(any-hover: hover)',
    dark: '(prefers-color-scheme: dark)',
    light: '(prefers-color-scheme: light)',
  },
  prefix: 'rk',
})

export type ReservoirKitThemeContext = {
  assets: {
    ethIcon: {
      value: ReservoirKitTheme['assets']['ethIcon']
    }
    chainIcon: {
      value: ReservoirKitTheme['assets']['chainIcon']
    }
  }
} & typeof theme
